import type { BillApiRow, BillListItem } from "features/boletos/types";

export function mapBillsForList(
  response: BillApiRow[] | undefined,
  hasDirectDebit: boolean | undefined
): { bills: BillListItem[]; overdueCount: number } {
  let overdueCount = 0;

  const bills = (response ?? []).map((item) => {
    if (hasDirectDebit && item.status === "VENCIDO") {
      const dueDate = new Date(String(item.dueDate));
      const currentDate = new Date();
      const diffInTime = currentDate.getTime() - dueDate.getTime();
      const diffInDays = diffInTime / (1000 * 3600 * 24);
      if (diffInDays > 7) {
        overdueCount += 1;
      }
    }

    const row: BillListItem = { invoice: item, installment: item };
    row.installment.paymentTypeBoleto = true;
    return row;
  });

  return { bills, overdueCount };
}
